export default __webpack_public_path__ + "static/media/times-new-roman-bold.336764e1.ttf";